
export default function Section({ title, subtitle, children }:{ title:string, subtitle?:string, children:any }) {
  return (
    <section className="mx-auto max-w-7xl px-4 py-16">
      <header className="mb-8">
        <h2 className="text-2xl md:text-3xl font-semibold">{title}</h2>
        {subtitle && <p className="mt-2 text-slate-400">{subtitle}</p>}
      </header>
      {children}
    </section>
  )
}
